/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 12th 2022, 6:39:20 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useCopyTextToClipBoard } from "lib/utils";
import { ToolBarItemButton } from "common/components/toolbar";
import { COLORSCHEME } from "theme/styles";
import Badge from "@mui/material/Badge";
import React from "react";

interface ContextTagButtonProps {
  iconComponent: React.ReactNode;
  tagName: string;
  tag: string;
  onCopyContextTag?: (args: { tag: string; tagName: string }) => void;
  copiedMessage?: string;
}

export const ContextTagButton = ({
  iconComponent,
  tagName,
  tag,
  onCopyContextTag,
  copiedMessage,
}: ContextTagButtonProps) => {
  const { copied, copyTextToClipBoard } = useCopyTextToClipBoard();

  React.useEffect(() => {
    if (copied) onCopyContextTag?.({ tag, tagName });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copied, tag]);

  return (
    <Badge
      onClick={() => copyTextToClipBoard(tag)}
      color="primary"
      badgeContent={copiedMessage ?? "Copied!!"}
      invisible={!copied}
    >
      <ToolBarItemButton
        tooltipText={null}
        buttonIcon={<div style={{ color: COLORSCHEME.secondary, fontSize: 25 }}>{iconComponent}</div>}
        buttonTitle={tagName}
        buttonCursor="pointer"
      />
    </Badge>
  );
};
